"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ConfiguratorAccessoriesSelector = void 0;

var _configuratorAccessoriesSelector = _interopRequireDefault(require("./components/configurator-accessories-selector"));

exports.ConfiguratorAccessoriesSelector = _configuratorAccessoriesSelector["default"];